export default __webpack_public_path__ + "static/property-img6-0ba233aaa1069f2b701439191079e79a.jpg";